"use client";

import { c as _c } from "react/compiler-runtime";
import type { ForwardRefExoticComponent, RefAttributes, SVGProps } from "react";
import { useSidebarLayout } from "@/layouts/app-shell/sidebar-layout";
import { cn } from "@/lib/utils";
import classes from "./navigation-logo.module.css";
type SvgComponent = ForwardRefExoticComponent<SVGProps<SVGSVGElement> & RefAttributes<SVGSVGElement>>;
interface NavigationLogoProps {
  logo: SvgComponent;
  variant?: "auto" | "full";
  className?: string;
}
export function NavigationLogo(t0) {
  const $ = _c(18);
  const {
    logo: Logo,
    variant: t1,
    className
  } = t0;
  const variant = t1 === undefined ? "auto" : t1;
  const {
    showCollapsedVisual,
    isMobile,
    phase
  } = useSidebarLayout();
  const isCollapsedLogo = variant === "auto" && !isMobile && (showCollapsedVisual || phase === "menu-out");
  const t2 = isCollapsedLogo && classes.linkCollapsed;
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn(classes.link, t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = isCollapsedLogo && classes.logoStageCollapsed;
  let t5;
  if ($[3] !== t4) {
    t5 = cn(classes.logoStage, t4);
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = isCollapsedLogo && classes.fullLayerCollapsed;
  let t7;
  if ($[5] !== t6) {
    t7 = cn(classes.fullLayer, t6);
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== Logo) {
    t8 = <Logo aria-hidden={true} className={classes.logoImage} />;
    $[7] = Logo;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7 || $[10] !== t8) {
    t9 = <div className={t7}>{t8}</div>;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5 || $[13] !== t9) {
    t10 = <div className={t5}>{t9}</div>;
    $[12] = t5;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t3) {
    t11 = <div aria-label="StreamHub" className={t3}>{t10}</div>;
    $[15] = t10;
    $[16] = t3;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}